// extracted by mini-css-extract-plugin
export default {"confirm-pop-up":"ConfirmPopUp_confirm-pop-up__yU44j","confirm-buttons":"ConfirmPopUp_confirm-buttons__45Gt2"};